export default () => ({
  channelData: {},
  channelsList: [],
});
